import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { ajaxGetMonthlySales } from '../../services/reportsService';
import LoadingButton from '../../components/LoadingButton';
import useAlert from '../../hooks/useAlert'
import moment from 'moment';

export default function MonthlySales() {
  
  const [date, setDate] = useState(moment());
  const [readyToDownload, setReadyToDownload] = useState(false);
  const errorAlert = useAlert(false, 'error');

  useEffect(() => {
    setReadyToDownload(date !== null);
  }, [date]);

  const handleDownload = (format) => () => {
    errorAlert.resetAlert();

    let filename = `monthly-sales_${date.format('YYYY')}-${date.format('MM')}.${format}`;

    // validate filename
    filename = filename.replace(/[\s/\\?%*:|"<>]/g, '');
    
    return ajaxGetMonthlySales({ format, month: date.format('M'), year: date.format('YYYY') }, filename)
      .catch((e) => {
        errorAlert.setAlert(e.message);
      });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DateCalendar
          disableFuture
          views={['year', 'month']}
          openTo="month"
          onMonthChange={setDate}
          onYearChange={setDate}
        />
      </Grid> 
      <Grid item xs={12}>
        <LoadingButton
          size="small"
          variant="contained"
          color="info"
          sx={{ margin: '10px 20px 10px 0' }}
          onClickPromise={handleDownload('pdf')}
          disabled={!readyToDownload}
        >
          Download in PDF
        </LoadingButton>
        <LoadingButton
          size="small"
          variant="contained"
          color="info"
          sx={{ margin: '10px 0' }}
          onClickPromise={handleDownload('csv')}
          disabled={!readyToDownload}
        >
          Download in CSV
        </LoadingButton>
      </Grid>
    </Grid>
  );
}
